import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import toast, { Toaster } from 'react-hot-toast';
import UsuarioService from '../../services/usuario.service';
import '../Password/Password.css'

const Password = (props) => {
	
  const [ t, i18n ] = useTranslation("global");
  
  const [passwordNueva, setPasswordNueva] = useState('')
  const [passwordNuevaRepetir, setPasswordNuevaRepetir] = useState('')
  const [passwordNuevaError, setPasswordNuevaError] = useState('')
  const [passwordNuevaRepetirError, setPasswordNuevaRepetirError] = useState('')
  
  const toastErrorToken = () => toast.error(t('app.error.tokenResetPassword'));
  const toastOkResetPwd = () => toast.success(t('app.mensaje.resetPasswordOK'));
  const toastErrorResetPwd = () => toast.error(t('app.error.resetPassword'));
  const toastGenericError = () => toast.error(t('app.error.login.generic'));
  
  useEffect(() => {
	  const userBrowserLang = getUserBrowserLanguage();

	  i18n.changeLanguage(userBrowserLang);
  }, [i18n]);
  
  const getUserBrowserLanguage = () => {
        const lang = window.navigator.language;

        if (lang.includes("es")) return "es";
        if (lang.includes("ca")) return "ca";
        if (lang.includes("en")) return "en";

        return "en";
  };
  
  const onButtonClick = (e) => {
		e.preventDefault();
		
		// Set initial error values to empty  
		setPasswordNuevaError('');
		setPasswordNuevaRepetirError('');

		// Check if the user has entered both fields correctly  	
		if ('' === passwordNueva) {
			setPasswordNuevaError(t('app.password.passwordNueva'))
			return
		}
		
		if ('' === passwordNuevaRepetir) {
			setPasswordNuevaRepetirError(t('app.password.passwordNuevaRepetir'))
			return
		}
		
		if (passwordNueva !== passwordNuevaRepetir) {
			setPasswordNuevaRepetirError(t('app.password.debeRepetir'))
			return
		}
		
		restablecerPassword(passwordNueva);
  }
  
  const restablecerPassword = async (passwordNueva) => {
		const queryParams = new URLSearchParams(window.location.search)
		const token = queryParams.get("token");
		
		if (token !== null && token !== '') {
			resetPwd(passwordNueva, token);
		} else {
			toastErrorToken();
		}
  }
  
  const resetPwd = async (passwordNueva, token) => {
		const toastLoading = toast.loading(t('app.mensaje.loading'));
	
		await UsuarioService.restablecerPwd(passwordNueva, token)
			.then((response) => {
	
				if (response.status === 200) {
					toast.dismiss(toastLoading);
	
					toastOkResetPwd();
				} else {
					toast.dismiss(toastLoading);
					
					toastErrorResetPwd();
				}
			})
			.catch((err) => {
				toast.dismiss(toastLoading);
	
				toastGenericError();
			});
  	}
	
  return (
	  <div className={'mainPasswordContainer'}>
		  <div className="login-form">
			  <div className="login-logo">
				  <a href={t("app.baseURL")}><img src={require("../../assets/img/logo.png")} alt="Login Logo" /></a>
			  </div>
			  <form onSubmit={onButtonClick}>
				  <div className={'inputContainerLogin'}>
					  <input
						  type='password'
						  value={passwordNueva}
						  placeholder={t("app.password.passwordNueva")}
						  onChange={(ev) => setPasswordNueva(ev.target.value)}
						  className={'inputBox'}
					  />
					  <label className="errorLabel">{passwordNuevaError}</label>
				  </div>
				  <br />
				  <div className={'inputContainerLogin'}>
					  <input
						  type='password'
						  value={passwordNuevaRepetir}
						  placeholder={t("app.password.passwordNuevaRepetir")}
						  onChange={(ev) => setPasswordNuevaRepetir(ev.target.value)}
						  className={'inputBox'}
					  />
					  <label className="errorLabel">{passwordNuevaRepetirError}</label>
				  </div>
				  <br />
				  <div className={'inputContainerLogin'}>
					  <input className={'inputButtonLogin'} type="submit" value={t("app.password.restaurar")} />
					  <Toaster />
				  </div>
			  </form>
		  </div>
	  </div>
  )
}

export default Password